module.exports = __webpack_public_path__ + "img/JamesWooldridge.23fc94a8.png";